module.exports = __webpack_public_path__ + "img/金林豪生1.0cfe3494.jpg";